import imgWhiteLogo1 from "../../assets/2ccda97ecaa4b401fe79d7f0575e654788a45c27.png";
import { useNavigate } from "react-router-dom";

function DonateButton() {
  const navigate = useNavigate();
  return (
    <button onClick={() => navigate('/donate')} className="bg-white text-[#00499d] rounded-full px-5 py-2 font-bold hover:scale-105 transition-transform">
      Donate
    </button>
  );
}

function FooterInfo() {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between text-white text-sm md:text-base w-full">
      <p>© 2026 Project Ontario</p>
      <a href="mailto:info@projectontario.ca" className="underline hover:opacity-80">info@projectontario.ca</a>
    </div>
  );
}

function DonateContent() {
  return (
    <div className="content-stretch flex flex-col gap-[20px] md:gap-[24px] items-center relative shrink-0 w-full">
      <div className="relative shrink-0" style={{ width: 36.139, height: 36.139 }}>
        <img alt="Project Ontario Logo" className="absolute inset-0 max-w-none object-cover pointer-events-none w-full h-full" src={imgWhiteLogo1} />
      </div>
      <div className="font-['Geist:Medium',_sans-serif] font-medium leading-[32px] md:leading-[48px] lg:leading-[54px] w-full relative shrink-0 text-[28px] md:text-[48px] lg:text-[54px] text-center text-white tracking-[-1.62px]">
        <p className="mb-0">Support Project Ontario</p>
      </div>
      <p className="font-['Geist:Regular',_sans-serif] font-normal leading-[20px] md:leading-[24px] relative shrink-0 text-[14px] md:text-[16px] text-center text-white tracking-[-0.32px] w-full max-w-[559px] px-2 md:px-0">
        Project Ontario is a non-profit organization funded by Ontarians who believe our province can do better. Your financial support helps us publish new ideas, host public events, and build momentum for serious conservative reform. Every contribution strengthens our work to put Ontario back on track.

      </p>
      <p className="font-['Geist:Regular',_sans-serif] font-normal leading-[18px] md:leading-[24px] relative shrink-0 text-[12px] md:text-[16px] text-center text-white tracking-[-0.32px] w-full max-w-[559px] px-2 md:px-0">Project Ontario is not a registered charity, and donations are not eligible for a tax receipt.</p>
      <DonateButton />
    </div>
  );
}

function FooterDivider() {
  return (
    <div className="relative w-full flex flex-col gap-[40px] items-start">
      <div className="relative w-full" aria-hidden="true">
        {/* Full-bleed line across viewport */}
        <div className="absolute left-1/2 -translate-x-1/2 w-screen h-px bg-white/50" />
        <div className="h-px" />
      </div>
      <FooterInfo />
    </div>
  );
}

export default function FooterSection() {
  return (
    <div className="relative w-full bg-[#00499d]" data-name="Donate">
      <div className="flex flex-col items-center justify-center w-full">
        <div className="box-border content-stretch flex flex-col gap-[40px] md:gap-[80px] lg:gap-[100px] items-center justify-center pb-[30px] md:pb-[40px] pt-10 md:pt-16 lg:pt-[100px] px-4 md:px-16 lg:px-[100px] relative w-full">
          <DonateContent />
          <FooterDivider />
        </div>
      </div>
    </div>
  );
}
